"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var usePayline = function () {
    if (typeof window === 'undefined')
        return;
    var Payline = window.Payline;
    if (!Payline)
        throw new Error('PaylineProvider is not rendered within the component tree.');
    return Payline.Api;
};
exports.default = usePayline;
//# sourceMappingURL=usePayline.js.map